import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { TextInput } from "../../../Components/Input/Input";
import { ButtonSave, ButtonClose } from "../../../Components/Button/Button";
import axios from "axios";
import { UrlApi, authorization } from "../../../UrlApi/UrlApi";
import Loading from "../../../Components/Loading/Loading";
import {
  AlertError,
  AlertSuccess,
} from "../../../Components/AlertDialog/AlertDialog";
import SelectAutoComplete from "../../../Components/Input/Input";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import { userData } from "../../../DataContext/DataContext";
import { useRecoilValue } from "recoil";
import Typography from '@mui/material/Typography';
import { SelectDate } from "../../../Components/Input/Input";
import moment from "moment";
import dayjs from "dayjs";

function AddDailyJobDetailsRecord(props) {
  const user = useRecoilValue(userData);
  const [loading, setLoading] = useState(false);
  const [codeSupErr, setCodeSupErr] = useState(false);
  const [codeSalesErr, setCodeSalesErr] = useState(false);
  const [noOrderErr, setNoOrderErr] = useState(false);
  const [securityCodeErr, setSecurityCodeErr] = useState(false);
  const [workAreaErr, setWorkAreaErr] = useState(false);
  const [zoneErr, setZoneErr] = useState(false);
  const [applicationTypeErr, setApplicationTypeErr] = useState(false);
  const [customerNameErr, setCustomerNameErr] = useState(false);
  const [employeeErr, setEmployeeErr] = useState(false);
  const [errorDateOfSubmission, setErrorDateOfSubmission] = useState(false);

  const [document, setDocument] = useState("");
  const [docudate, setDocudate] = useState("");
  const [salesName, setSalesName] = useState("");
  const [salesEmpId, setSalesEmpId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [applicationTypeId, setApplicationTypeId] = useState("");
  const [applicationTypeName, setApplicationTypeName] = useState("");
  const [codeSub, setCodeSub] = useState("");
  const [noOrder, setNoOrder] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [codeSales, setCodeSales] = useState("");
  const [areaName, setAreaName] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [empId, setEmpId] = useState("");
  const [empName, setEmpName] = useState("");
  const [remark, setRemark] = useState("");
  const [customerAppointmentDate, setCustomerAppointmentDate] = useState(dayjs());
  const [dateOfSubmission, setDateOfSubmission] = useState(dayjs());

  const [codeSalesData, setCodeSalesData] = useState([]);
  const [applicationTypeData, setApplicationTypeData] = useState([]);
  const [areaData, setAreaData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const inputRefs = useRef([]);

  const textFieldForUsernameRef = useRef(null);
  const textFieldForPasswordRef = useRef(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (codeSub === "") {
      setCodeSupErr(true);
      return false;
    } else {
      setCodeSupErr(false);
    }
    if (salesEmpId === "") {
      setCodeSalesErr(true);
      return false;
    } else {
      setCodeSalesErr(false);
    }
    if (empId === "") {
      setEmployeeErr(true);
      return false;
    } else {
      setEmployeeErr(false);
    }
    if (applicationTypeId === "") {
      setApplicationTypeErr(true);
      return false;
    } else {
      setApplicationTypeErr(false);
    }
    if (noOrder === "") {
      setNoOrderErr(true);
      return false;
    } else {
      setNoOrderErr(false);
    }
    if (customerName === "") {
      setCustomerNameErr(true);
      return false;
    } else {
      setCustomerNameErr(false);
    }
    if (securityCode === "") {
      setSecurityCodeErr(true);
      return false;
    } else {
      setSecurityCodeErr(false);
    }
    if (areaId === "") {
      setWorkAreaErr(true);
      return false;
    } else {
      setWorkAreaErr(false);
    }
    if (zoneId === "") {
      setZoneErr(true);
      return false;
    } else {
      setZoneErr(false);
    }

    const body = {
      customerAppointmentDate,
      dateOfSubmission,
      code_sub: codeSub,
      customer_name: customerName,
      salesEmpId,
      empId,
      applicationTypeId,
      no_order: noOrder,
      security_code: securityCode,
      areaId,
      zoneId,
      remark,
      save_emp_master_id: user.user_id,
      documentId: props.documentId,
      status_id: 1
    };
    if (props.documentId === null) {
      setLoading(true);
      await axios
        .post(UrlApi + "save_document", body, authorization)
        .then((res) => {
          props.onCancel();
          AlertSuccess(res.data.message, ()=>{}, 2000);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    } else {
      setLoading(true);
      await axios
        .post(UrlApi + "update_document", body, authorization)
        .then((res) => {
          props.onCancel();
          AlertSuccess(res.data.message,  ()=>{}, 2000);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }
  };

  const getData = async () => {
    if (props.documentId === null) {
      setLoading(true);
      await axios
        .get(UrlApi + "get_document", authorization)
        .then((res) => {
          setDocument(res.data[0].fn_app_create_document);
          setDocudate(res.data[0].docudate);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }

    if (props.documentId !== null) {
      setLoading(true);
      await axios
        .get(
          UrlApi + `get_document_data_for_edit?document_id=${props.documentId}`,
          authorization
        )
        .then((res) => {
          setDocument(res.data[0].docuno);
          setDocudate(res.data[0].docudate);
          setCodeSub(res.data[0].sup_code);
          setSalesEmpId(res.data[0].sales_emp_master_id);
          setSalesName(res.data[0].sale_name);
          setEmpId(res.data[0].emp_master_id);
          setEmpName(res.data[0].emp_name);
          setApplicationTypeId(res.data[0].job_type_id);
          setApplicationTypeName(res.data[0].job_type_name);
          setNoOrder(res.data[0].listno_order);
          setCustomerName(res.data[0].customer_name);
          setSecurityCode(res.data[0].security_code);
          setAreaId(res.data[0].order_area_id);
          setZoneId(res.data[0].zone_master_id);
          setSalesName(res.data[0].sale_name);
          setCodeSales(res.data[0].emp_code);
          setAreaName(res.data[0].order_area_name);
          setZoneName(res.data[0].zone_master_name);
          setRemark(res.data[0].remark);
          setDateOfSubmission(dayjs(res.data[0].delivery_date));
          setCustomerAppointmentDate(dayjs(res.data[0].appointment_date));
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
        });
    }

    setLoading(true);
    await axios
      .get(UrlApi + "get_code_sales_data", authorization)
      .then((res) => {
        setCodeSalesData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
    });

    setLoading(true);
    await axios
      .get(UrlApi + "get_application_type_data", authorization)
      .then((res) => {
        setApplicationTypeData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

    setLoading(true);
    await axios
      .get(UrlApi + "get_area_data", authorization)
      .then((res) => {
        setAreaData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

    setLoading(true);
    await axios
      .get(UrlApi + "get_zone_data", authorization)
      .then((res) => {
        setZoneData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });

      setLoading(true);
      await axios
        .get(UrlApi + "get_employee", authorization)
        .then((res) => {
          setEmployeeData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          AlertError(err);
      });
  };

  const handleEnter = (event) => {
      const id = parseInt(event.target.id);
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      let next = 2;
      if(event.key === "Enter"){
        if(id === 9){
          onSubmit(event);
          return false;
        }
        switch (id){
          case 2:
            next = 5;
            break;
          case 3:
            next = 4;
            break;
          case 7:
            next = 4;
            break;
          case 8:
              next = 4;
            break;
          default:
            next = 2;
        }
        form.elements[index + next].focus();
        event.preventDefault();
      }
    
  };

  const marginLeft = {
    marginLeft: "9px",
  };


  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Dialog
        open={props.open}
        maxWidth="1500"
        PaperProps={{ style: { borderRadius: 10 } }}
      >
        <Box component="form" noValidate onSubmit={(e)=>{onSubmit(e)}} sx={{ mt: 1 }}>
          <DialogTitle>
            <label>
              {props.documentId === null
                ? "เพิ่มบันทึกงานสำเร็จประจำวัน"
                : "แก้ไขบันทึกงานสำเร็จประจำวัน"}
            </label>
          </DialogTitle>
          <DialogContent dividers="paper">
            <form>
              <table>
                <tr>
                  <td colspan="2" style={{ paddingLeft: "9px" }}>
                    <label>เลขที่เอกสาร</label>
                    <br />
                    {document}
                  </td>
                  <td colspan="1" style={{ paddingLeft: "9px" }}>
                    <label>วันที่เอกสาร</label>
                    <br />
                    {docudate}
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label style={marginLeft}>วันที่นัดลูกค้า</label>
                    {
                      <SelectDate onChange={(date)=>{
                        setCustomerAppointmentDate(date);
                      }}                
                      value={customerAppointmentDate}/>
                    }
                  </td>
                  <td>
                    <label style={marginLeft}>วันที่ส่งเอกสาร</label>
                    {
                      <SelectDate onChange={(date)=>{
                        setDateOfSubmission(date);
                      }}                  
                      value={dateOfSubmission}/>
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <label style={marginLeft}>Code Sub</label>
                    {
                      <TextInput                     
                        id="1"
                        autoFocus={true}
                        value={codeSub}
                        onChange={(e) => {
                          setCodeSub(e.target.value);
                          setCodeSupErr(false);
                        }}
                        error={codeSupErr}
                        onKeyDown={handleEnter}
                        width="100%"                      
                      />
                    }
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td>
                    <label style={marginLeft}>Code Sales</label>
                    {
                      <SelectAutoComplete
                        id="2"
                        options={codeSalesData}
                        onChange={(value, valueText) => {
                          setCodeSales(valueText.split(':')[0].trim());
                          setCodeSalesErr(false);
                          codeSalesData.find((item) => {
                            if (item.value === value) {
                              setSalesName(item.full_name);
                            }
                            setSalesEmpId(value);
                          });
                        }}
                        error={codeSalesErr}
                        value={codeSales}
                        onInputChange={(event, newInputValue) => {}}
                        onKeyDown={handleEnter}                   
                      />
                    }
                  </td>
                  <td colspan="3">
                    <label style={marginLeft}>ชื่อ Sales</label>
                    {
                      <TextInput
                        disabled={true}
                        value={salesName}
                        error={codeSalesErr}
                        variant="standard"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>ชื่อพนักงาน</label>
                    {
                      <SelectAutoComplete
                        id="8"
                        options={employeeData}
                        onChange={(value, valueText) => {
                          setEmpId(value);
                          setEmpName(valueText);
                          setEmployeeErr(false);
                        }}
                        error={employeeErr}
                        value={empName}
                        onInputChange={(event, newInputValue) => {}}
                        onKeyDown={handleEnter}
                        width="100%"                      
                      />
                    }
                  </td>              
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>ประเภทใบสมัคร</label>
                    {
                      <SelectAutoComplete
                        id="3"
                        options={applicationTypeData}
                        onChange={(value, valueText) => {
                          setApplicationTypeName(valueText);
                          setApplicationTypeErr(false);
                          setApplicationTypeId(value);
                        }}
                        error={applicationTypeErr}
                        value={applicationTypeName}
                        onInputChange={(event, newInputValue) => {}}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>No.ใบสั่ง</label>
                    {
                      <TextInput
                        id="4"
                        type="text"
                        onChange={(e) => {
                          setNoOrder(e.target.value);
                          setNoOrderErr(false);
                        }}
                        error={noOrderErr}
                        value={noOrder}
                        onKeyDown={handleEnter}
                        width="100%"                      
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>ชื่อ-สกุลลูกค้า</label>
                    {
                      <TextInput
                        id="5"
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                          setCustomerNameErr(false);
                        }}
                        error={customerNameErr}
                        value={customerName}
                        onKeyDown={handleEnter}
                        width="100%"
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>Security Code</label>
                    {
                      <TextInput
                        id="6"
                        type="text"
                        onChange={(e) => {
                          setSecurityCode(e.target.value);
                          setSecurityCodeErr(false);
                        }}
                        error={securityCodeErr}
                        value={securityCode}
                        onKeyDown={handleEnter}
                        width="100%"
                        maxLength={13}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>พื้นที่สั่งงาน</label>
                    {
                      <SelectAutoComplete
                        id="7"
                        options={areaData}
                        onChange={(value, valueText, otherValue) => {
                          zoneData.map((item)=>{
                            if(item.value === otherValue){                   
                              setZoneName(item.label);
                              setZoneId(item.value);
                            }
                          });
                          
                          setAreaName(valueText.split(':')[0].trim());
                          setAreaId(value);
                          setWorkAreaErr(false);
                        }}
                        value={areaName}
                        onInputChange={(event, newInputValue) => {}}
                        error={workAreaErr}
                        width="100%"
                        onKeyDown={handleEnter}
                      />
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <label style={marginLeft}>โซน</label>
                    {
                      <Typography variant="subtitle1" style={{marginLeft: '10px', fontFamily: 'Sarabun'}}>
                      {zoneName}
                      </Typography>
                    }
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <label style={marginLeft}>หมายเหตุ</label>
                    {
                      <TextInput                     
                        id="9"
                        autoFocus={true}
                        value={remark}
                        onChange={(e) => {
                          setRemark(e.target.value);
                        }}
                        onKeyDown={handleEnter}
                        width="100%"                      
                      />
                    }
                  </td>
                </tr>
              </table>
            </form>
          </DialogContent>
          <DialogActions>
            <ButtonSave type="submit" />
            <ButtonClose onClick={() => props.onCancel()} />
          </DialogActions>
          <Loading open={loading} />
        </Box>
      </Dialog>
    </>
  );
}

export default AddDailyJobDetailsRecord;
